import React from 'react';
import { TypeCard } from '../../../../components/TypeCard';
import { handleProductName } from '../../../../utils';
import { Resources } from '../../../../models/ScheduleResource';

const stethoscopeIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/estetoscopio.svg';

type ProductListProps = {
  products: Resources[];
  setProductList: (list: Resources[]) => void;
  selected?: Resources;
  handleSelect: (props: Resources) => void;

  showIcon?: boolean;
};

export const ProductList: React.FC<ProductListProps> = ({ products, selected, handleSelect, showIcon = true }) => {
  const getIcon = (icon: string): any => `https://agendamento-images-nprd.telemedicinaeinstein.com.br/icons/${icon}`;

  return (
    <>
      {products.map(product => (
        <TypeCard
          key={product.id}
          title={handleProductName(product.name)}
          iconSrc={showIcon ? (product.icon ? getIcon(product.icon) : stethoscopeIcon) : undefined}
          iconWrapper={showIcon}
          onClick={() => handleSelect(product)}
          checked={selected ? selected.id === product.id : false}
        />
      ))}
    </>
  );
};
